import { AppTabList, AppTabListProps } from './AppTabList'
import { AppTab } from './AppTab'
import { AppBox } from '../AppBox'
import { NotOverridableComponentProps } from '../../../../../model/Component'
import { handlePassedSx } from '../../../../../feature/theme/model/Sx'

export type AppTabsProps<T extends string> = Omit<NotOverridableComponentProps<AppTabListProps>, 'onChange'> & {
  tabs: Array<{
    label: string
    value: T
  }>
  onChange: (value: T) => void
  tabSx?: object
}

export function AppTabs<T extends string>(props: AppTabsProps<T>) {
  const { value, onChange, tabs, sx = [], tabSx = [], ...rest } = props

  const handleChange = (_event: React.SyntheticEvent, newValue: T) => {
    onChange(newValue)
  }

  return (
    <AppBox sx={sx}>
      <AppTabList
        value={value}
        onChange={handleChange}
        aria-label="tabs"
        sx={[
          styles.tabList,
          ...handlePassedSx(sx),
        ]}
        {...rest}
      >
        {tabs.map(tab => (
          <AppTab
            key={tab.value}
            label={tab.label}
            value={tab.value}
            sx={[
              styles.tab,
              ...handlePassedSx(tabSx),
            ]}
          />
        ))}
      </AppTabList>
    </AppBox>
  )
}

const styles = {
  tabList: {
    backgroundColor: 'background.paper',
    borderRadius: '10px',
    padding: '1px',
    minHeight: 'auto',
    '& .MuiTabs-indicator': {
      display: 'none',
    },
  },
  tab: {
    textTransform: 'none',
    fontWeight: 500,
    fontSize: 12,
    borderRadius: '10px',
    minHeight: '32px',
    padding: '6px 14px',
    transition: 'all 0.2s ease',
    '&.Mui-selected': {
      backgroundColor: 'background.dark',
      fontWeight: 600,
    },
    '&:hover': {
      backgroundColor: 'action.hover',
    },
    '&.Mui-selected:hover': {
      backgroundColor: 'primary.dark',
    },
  },
}
